<!-- src/App.vue 主组件-->
<template>
  <div id="app">
    <template v-if="isShowHeader">
      <HeaderView :isNavVisible="isNavVisible" :isNavTop="isNavTop"/>
    </template>
    <AiConsultFloatingButton v-if="route.name !== 'aiConsult'"/>
    <router-view @hook:mounted="handleMounted"></router-view>
    <template v-if="isShowFooter">
      <FooterView class="footer"/>
    </template>
  </div>
</template>

<script setup>
import HeaderView from "@/components/common/HeaderView.vue"
import AiConsultFloatingButton from "@/components/common/AiConsultFloatingButton.vue"
import {debounce} from "lodash"
import router from "@/router/router.js";
import FooterView from "@/components/common/FooterView.vue";
import {useRoute} from "vue-router";

const lastScrollY = ref(0)
const isNavVisible = ref(true)
const isShowHeader = ref(true)
const isShowFooter = ref(false)
const isNavTop = ref(true)
const route = useRoute()

const currentRouteMeta = computed(() => {
  return router.currentRoute.value.meta
})

watch(currentRouteMeta, (newMeta) => {
  if (Object.prototype.hasOwnProperty.call(newMeta, 'isShowHeader')) {
    isShowHeader.value = newMeta.isShowHeader
  }
}, {immediate: true})


// 处理滚动事件
const handleWheel = debounce(() => {
  const currentScrollY = window.scrollY || document.documentElement.scrollTop
  isNavVisible.value = currentScrollY <= lastScrollY.value
  lastScrollY.value = currentScrollY
  isNavTop.value = currentScrollY <= 200
}, 100)  // 100ms 防抖

const handleMounted = () => {
  nextTick(() => {
    // 执行其他操作
    isShowFooter.value = true
  })
}

// 监听路由变化
watch(
    () => route.fullPath, // 监听路由的 fullPath 变化
    () => {
      window.scrollTo(0, 0)
      isShowFooter.value = false
      setTimeout(() => {
        isShowFooter.value = true
      }, 400)
    }
)

// 禁止右键复制粘贴
document.addEventListener('DOMContentLoaded', function () {
  //复制
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
  })

  //粘贴
  // document.addEventListener('paste', function (e) {
  //   e.preventDefault();
  // })
})

// 在组件挂载时添加滚动事件监听
onMounted(() => {
  // 监听 wheel 滚轮事件
  // window.addEventListener('wheel', handleWheel, {passive: true})
  // 监听 scroll 滚动条事件
  window.addEventListener('scroll', handleWheel, {passive: true})
  // 禁止窗口缩放事件
  window.addEventListener('wheel', (event) => {
    if (event.ctrlKey) {
      event.preventDefault(); // 阻止默认缩放
    }
  }, {passive: false})
})

// 在组件销毁前移除滚动事件监听
onBeforeUnmount(() => {
  window.removeEventListener('wheel', handleWheel)
  window.removeEventListener('scroll', handleWheel)
})

</script>

<!----scoped 样式只在当前组件生效------>
<style scoped>

</style>
